<template>
  <div class="merchants">
    <div class="merchants__head__box">
      <img class="merchants__head" :src="business.headImg.url" alt="">
      <template v-if="business.auditStatus === 1">
         <div class="audit-status--en">
          <img src="@/assets/imgs/goods/audit.png" alt="">
        </div>
      </template>
    </div>
    <div class="merchants__name">{{ business.name }}</div>
  </div>
</template>
<script>
export default {
    props: {
        business: Object
    },
    data () {
        return {
            audit: 'https://fr-static.shopshops.top/20210216/audit-status.442da4bec8ff382d.png',
        }
    }
}
</script>
<style lang="less" scoped>
.merchants{
  display: flex;
  padding: 4px;
  background: rgba(47,47,47,0.30);
  border-radius: 34px;
  align-items: center;
  .merchants__head__box{
    position: relative;
    height: 30px;
    .merchants__head{
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: #fff;
    }
    .audit-status{
      padding: 4px;
      position: absolute;
      background: #39D2D6;
      bottom: -8px;
      left: 50%;
      font-size: 11px;
      color: #ffffff;
      white-space: nowrap;
      border-radius: 11px;
      transform: translateX(-50%) scale(0.7);
    }
    .audit-status--en{
      width: 16px;
      height: 16px;
      position: absolute;
      left: 50%;
      bottom: -8px;
      transform: translateX(-50%);
      img{
        width: 100%;
        vertical-align: top;
      }
    }
  }
  .merchants__name{
    font-size: 11px;
    color: #ffffff;
    margin: 0 8px;
    font-family: "TradeGothicLT";
  }
}
</style>